import { Typography } from 'antd';

import PageWrapper from '../MainPageWrapper/PageWrapper';
import { termsContent } from './Terms.const';
import css from '../About/About.module.css';

const Terms = () => {
  const { Title } = Typography;

  return (
    <PageWrapper>
      <Title level={2} style={{ color: '#1677ff' }}>
        Пользовательское соглашение интернет-ресурса bilet.rabt.by
      </Title>
      <div className={css.Text} dangerouslySetInnerHTML={{ __html: termsContent }} />
    </PageWrapper>
  );
};

export default Terms;
